<template>
  <b-card id="wrapperCard" header-tag="header">
    <template #header>
      <h6 class="mb-0" style="text-align: center">
        Enviar prestações anuais para o eTce
      </h6>
    </template>
    <b-card-text>
      <b-row align-h="center">
        <b-col xs="12" md="3">
          <b-form-group class="formGroup font-weight-bold" id="ano-input-group" label="Ano *" label-for="input-ano"
            label-cols="auto">
            <b-form-select id="input-ano" v-model="anoSelecionado" :options="anosDisponiveis" @change="checarStatus()"
              :disabled="estaEnviandoPCAs"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col xs="12" md="6" class="my-auto">
          <span>{{ this.msgStatus }}</span>
          <b-progress :value="barCurrent" :max="barMax" show-value v-if="barMax"></b-progress>
        </b-col>
        <b-col xs="12" md="3" class="my-auto" v-if="anoSelecionado && anoSelecionado >= 1">
          <b-button block @click="enviarPrestacoes" :disabled="estaEnviandoPCAs || isBusy">
            <b-spinner small class="mr-2" v-if="estaEnviandoPCAs || isBusy" />
            <font-awesome-icon icon="paper-plane" class="mr-2" v-else />
            Enviar para o eTCE
          </b-button>
        </b-col>
      </b-row>
      <div id="resultadoEnvio">
        <h4 style="text-align: center">Prestações pendentes {{ anoSelecionado? 'de '+anoSelecionado : ''}}</h4>
        <b-table id="table-exportar-pca" :busy="isBusy" :fields="fields" hover no-border-collapse
          :items="listaPrestacoesAno" :sort-desc="true" striped small show-empty>
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
        </b-table>
      </div>
    </b-card-text>
  </b-card>
</template>

<script>
import exportarPcaService from "@/services/entregas/exportarPcaService";

export default {
  data() {
    return {
      isBusy: true,
      qtdPrestacoesPendentes: null,
      estaEnviandoPCAs: false,
      anoSelecionado: null,
      anosDisponiveis: [],
      listaPrestacoesAno: [],
      fields: [
        {
          key: "IdPrestacaoConta",
          label: "ID",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: false,
        },
        {
          key: "DataSituacao",
          label: "Data de assinatura",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: false,
        },
        {
          key: "NomeUnidadeGestora",
          label: "UG",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: false,
        },
        {
          key: "Detalhes",
          label: "Detalhes",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: false,
        },
      ],

      //controles da progressbar
      barMax: null,
      barCurrent: null,
    };
  },
  computed: {
    msgStatus() {
      if (this.isBusy) {
        return 'Carregando';
      }
      if (this.anoSelecionado) {
        return `${this.qtdPrestacoesPendentes} prestações ainda não enviadas ao eTCE.`;
      }
      return 'Selecione um ano na lista ao lado';

    }
  },
  methods: {
    async carregarAnosDisponiveis() {
      try {
        const responseAnos = await exportarPcaService.getAnos();
        if (responseAnos && Array.isArray(responseAnos.data)) {
          this.anosDisponiveis = [
            { text: "SELECIONE", value: null },
            ...responseAnos.data.map((a) => {
              return { text: `${a}`, value: a };
            }),
          ];
        } else {
          console.error("responseAnos", responseAnos);
          this.$toast.error(
            "Erro ao obter a lista de anos disponíveis. Consulte o log do browser e da api."
          );
        }
      } finally {
        this.isBusy = false;
      }
    },
    async checarStatus() {
      try {
        this.isBusy = true;
        this.qtdPrestacoesPendentes = null;
        this.listaPrestacoesAno = [];
        if (this.anoSelecionado && this.anoSelecionado != null) {
          const responsePrestacoesAno = await exportarPcaService.listarPrestacoes(this.anoSelecionado);
          this.qtdPrestacoesPendentes = responsePrestacoesAno.data.length;
          this.listaPrestacoesAno = responsePrestacoesAno.data;
        }
      } finally {
        this.isBusy = false;
      }
    },
    async enviarPrestacoes() {
      //console.log('iniciando loop enviarPrestacoes');
      this.estaEnviandoPCAs = true;
      this.barMax = this.qtdPrestacoesPendentes;
      this.barCurrent = 0;
      try {
        for (const pca of this.listaPrestacoesAno) {
          //console.log('iniciando a pca ' + pca.IdPrestacaoConta);
          if (pca.Descricao === null) {
            //console.log('descricao null, pca pendente, vou enviar para o BE');
            await this.enviarUmaPrestacao(pca);
          } else {
            console.log('descricao = ' + pca.Descricao + '. Nao vou enviar para o BE');
          }
          this.qtdPrestacoesPendentes--;
          this.barCurrent++;
        }
      } finally {
        this.estaEnviandoPCAs = false;
        this.barMax = null;
        this.barCurrent = null;
      }
    },
    async enviarUmaPrestacao(pca) {
      try {
        const response = await exportarPcaService.enviarUmaPrestacao(pca);
        console.log('enviei a pca ' + pca.IdPrestacaoConta);
        console.log('retorno:', response);
        console.log('find pca no array: ', this.listaPrestacoesAno.find(pc => pc.IdPrestacaoConta === pca.IdPrestacaoConta));
        this.listaPrestacoesAno.find(pc => pc.IdPrestacaoConta === pca.IdPrestacaoConta).Detalhes = response.data.descricao;
        this.$root.$emit('bv::refresh::table', 'table-exportar-pca')
      } catch (err) {
        console.error('Erro no método enviarUmaPrestacao, para a pca', pca);
        console.error(err);
      }
    },
  },
  mounted() {
    this.carregarAnosDisponiveis();
  },
};
</script>


<style>
#wrapperCard {
  text-align: left;
  margin: 20px auto !important;
  width: 95%;
}

.fieldContainer {
  height: 100%;
  display: flex;
  align-items: center;
}
</style>